
export enum MessageTypes {
    Info = "Info",
    Warning = "Warning",
    Error = "Error",
    Success = "Success",
    SuccessNotify = "SuccessNotify",
    PopUp = "PopUp",
    None = "None"
};